import Home from './pages/outer/home'
import About from './pages/outer/about'
import Blog from './pages/outer/blog'
import BlogDetail from './pages/outer/blog/detail'
import BlogSearch from './pages/outer/blog/searchResult'
import Support from './pages/outer/support'
import ActivateBenefits from './pages/outer/support/activateBenefits'
import AfterService from './pages/outer/support/afterService'
import MaintenancePrice from './pages/outer/support/maintenancePrice'
import FrequentlyAskedQuestion from './pages/outer/support/frequentlyAskedQuestion'
import ContactSupport from './pages/outer/support/contactSupport'
import ProductSupport from './pages/outer/support/productSupport'
import ProductParameter from './pages/outer/support/productParameter'
import PopularForums from './pages/outer/support/popularForums'
import ContentDetail from './pages/outer/support/contentDetail'
import Search from './pages/outer/support/searchResult'
import RepairProcess from './pages/outer/support/repairProcess'
import UsageGuide from './pages/outer/support/usageGuide'
import Shop from './pages/outer/shop'
import ShopList from './pages/outer/shop/offlineShop'
import ServiceShopList from './pages/outer/shop/serviceShop'
import NearestShopList from "./pages/outer/shop/nearestShop"
import Game from './pages/outer/game'
import GameCategory from './pages/outer/game/category'
import GameDetail from './pages/outer/game/detail'
import Newsroom from './pages/outer/newsroom'
import NewsroomDetail from './pages/outer/newsroom/detail'
import Accessory from './pages/outer/accessory'
import AccessoryDetail from './pages/outer/accessory/detail'
import Software from './pages/outer/software'


const _ = require('lodash')

export interface IRoute {
  exact: boolean
  path?: string | undefined
  component: string | unknown
}

const COUNTRY_LIST = ['cn', 'fr', 'de', 'it', 'jp', 'kr', 'th', 'my', 'nl', 'sg', 'es', 'uk', 'global'];

const routesList = [
  {
    path: '/',
    component: Home,
    exact: true
  },
  {
    path: '/about',
    component: About,
    exact: true
  },
  {
    path: '/blog',
    component: Blog,
    exact: true
  },
  {
    path: '/blog/search',
    component: BlogSearch,
    exact: true
  },
  {
    path: '/blog/:seoUrl',
    component: BlogDetail,
    exact: true
  },
  {
    path: '/support',
    component: Support,
    exact: true
  },
  {
    path: '/support/activate-benefits',
    component: ActivateBenefits,
    exact: true
  },
  {
    path: '/support/after-service',
    component: AfterService,
    exact: true
  },
  {
    path: '/support/maintenance-price',
    component: MaintenancePrice,
    exact: true
  },
  {
    path: '/support/faq',
    component: FrequentlyAskedQuestion,
    exact: true
  },
  {
    path: '/support/contact-support',
    component: ContactSupport,
    exact: true
  },
  {
    path: '/support/product-support/:productName',
    component: ProductSupport,
    exact: true
  },
  {
    path: '/support/product-parameter/:id',
    component: ProductParameter,
    exact: true
  },
  {
    path: '/support/popular-forums/:seoUrl',
    component: PopularForums,
    exact: true
  },
  {
    path: '/support/search-content/:seoUrl',
    component: ContentDetail,
    exact: true
  },
  {
    path: '/support/search',
    component: Search,
    exact: true
  },
  {
    path: '/support/repair-process',
    component: RepairProcess,
    exact: true
  },
  {
    path: '/support/usage-guide',
    component: UsageGuide,
    exact: true
  },
  {
    path: '/shop',
    component: Shop,
    exact: true
  },
  {
    path: '/shop/offline-shop',
    component: ShopList,
    exact: true
  },
  {
    path: '/shop/service-shop',
    component: ServiceShopList,
    exact: true
  },
  {
    path: '/shop/nearest-shop',
    component: NearestShopList,
    exact: true
  },
  {
    path: '/game',
    component: Game,
    exact: true
  },
  {
    path: '/game/catagory',
    component: GameCategory,
    exact: true
  },
  {
    path: '/game/:id',
    component: GameDetail,
    exact: true
  },
  {
    path: '/newsroom',
    component: Newsroom,
    exact: true
  },
  {
    path: '/newsroom/:id',
    component: NewsroomDetail,
    exact: true
  },
  {
    path: '/accessory',
    component: Accessory,
    exact: true
  },
  {
    path: '/accessory/:id',
    component: AccessoryDetail,
    exact: true
  },
  {
    path: '/software',
    component: Software,
    exact: true
  }
]

const crtyRouteList = COUNTRY_LIST.reduce((prev, cur) => {
  let _routesList = _.cloneDeep(routesList)
  return prev.concat(_routesList.map((item:IRoute) => {
    item.path = '/' + cur + item.path
    return item
  }))
}, [])

const indexRoutes = [...crtyRouteList, ...routesList]

export default indexRoutes